import { h } from 'preact';
export const ArrowUpRight = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("line", { x1: "7", y1: "17", x2: "17", y2: "7" }),
        h("polyline", { points: "7 7 17 7 17 17" })));
};
//# sourceMappingURL=arrow-up-right.js.map